export default "__VITE_ASSET__DmKSnB55__"